import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';
import ProductItem from '../components/product/ProductItem';

export default class DynamicMediaSlider {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.cardGap = section.data.cardGap * 4;
    this.cardsMobile = section.data.cardsMobile || 4;
    this.cardsTablet = section.data.cardsTablet || 4;
    this.cardsNormalDesktop = section.data.cardsNormalDesktop || 6;
    this.cardsLargeDesktop = section.data.cardsLargeDesktop || 8;

    const breakpoints = {
      [unitlessBreakpoints.md]: {
        perPage: this.cardsTablet,
      },
      [unitlessBreakpoints.lg]: {
        perPage: this.cardsNormalDesktop,
      },
      [unitlessBreakpoints.xl]: {
        perPage: this.cardsLargeDesktop,
      },
    };

    initCarousel(this.el, {
      perPage: this.cardsMobile,
      gap: this.cardGap,
      breakpoints,
    });

    // Initialize quick shop for product items
    const productItems = this.el.querySelectorAll('[data-product-item]');
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });
  }
}
